export const EIM_THEME_STORAGE_KEY = 'eim-theme-mode';